import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCWBfsvLrEGHWJNhlOBpN7Ua_W2eyg8Zs8",
  authDomain: "nestdata-2e41e.firebaseapp.com",
  projectId: "nestdata-2e41e",
  storageBucket: "nestdata-2e41e.firebasestorage.app",
  messagingSenderId: "27458081146",
  appId: "1:27458081146:web:0f719bd576eed9b15ec6c3",
};


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export {app,db}